export var packageName = "@atlassian/notification-store" || '@atlassian/notification-store';
export var packageVersion = "4.3.1" || 'v0.0.0';